
/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import { APP_BASE_HREF, registerLocaleData, DatePipe } from "@angular/common";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgModule, LOCALE_ID, APP_INITIALIZER } from "@angular/core";

import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { CoreModule } from "./@core/core.module";
// import { AutocompleteLibModule } from "angular-ng-autocomplete";
import { NgxLoadingModule } from "ngx-loading";

import { AppComponent } from "./app.component";
import { AppRoutingModule } from "./app-routing.module";
import { ThemeModule } from "./@theme/theme.module";
import { NgbModule, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AuthModule } from "./auth/auth.module";
import { SharedModule } from "./shared/shared.module";
import { ConfirmacaoComponent } from "./shared/confirmacao/confirmacao.component";
import { LoginService } from "./services/login.service";
import { AgmCoreModule } from '@agm/core';
import { TiposDeProdutosService } from './services/cadastro/tipos-de-produtos.service'
import { RiuService } from './services/gerenciamento/riu.service'
import { BlackListHotelService } from "./services/gerenciamento/blacklist-hotel.service";
import { NbDatepickerModule } from '@nebular/theme';
import { NbMomentDateModule } from '@nebular/moment';


import {
  UsuarioService, CidadeService, EstadoService, PaisService, AuthInterceptor,
  EmpresaService, ConfirmacaoService, LogService, ServicoService, LoaderInterceptor,
  LoaderService, AereoService, CircuitoService, AeroportoService, HotelService, CarroService, SeguroService, AgenciaService, CasaService,
  PerfilMarkupService, HotelofflineService, CategoriaOfflineApartamentoService,
  OfflineApartamentoService, ReservaService, WsService, MarkupService, CacheHotelService,
  MoedaService, SubFornecedorService, CambioService, MarkdownService, PerfilUsuarioService,
  PermissaoService, TarifacategoriaOfflineApartamentoService, ServicoOfflineService,
  ParametroService, ServicoOfflineFornecedorService, FormaPagamentoService, ContratosService,
  CondicaoPagamentoService, ServicoOfflineTarifaService, ServicoOfflineTarifaFaixaEtariaService,
  ServicoOfflinePerguntaService, ServicoOfflinePerguntaOpcaoService, OfflineHotelRegraTarifariaService,
  OfflineHotelManutencaoPeriodoService, OfflineHotelPromocaoTarifaService, BloqueioAereoService, OfflineServicoManutencaoPeriodoService,
  BloqueioAereoVooService, ProfissaoService, FinanciamentoService, TeleVendasPagamentoService, LaminasService,
  LojasCarroService, DashboardService, HotelBedsService, EzlinkService, TBOService, OfflineApartamentoRegimeService, PalladiumService, IntranetCategoriaService,
  OfflineApartamentoDisponibilidadeService, ReservaGestaoService, GrupoEconomicoService, FaturaService, RestelService, ProdutoOfflineService,
  ProdutoOfflineItemService, ProdutoOfflineFornecedorService, ProdutoTipoService, ServicoOfflineTipoService, RelatorioService, PacoteService, PacoteDestinoService, PacoteHotelService, PacoteIncluiService, PacotePeriodoService,
  MarkupOfflineServicoService, PacoteBloqueioAereoService, PacoteTarifaService, EventoService, ProgramacaoService, CronogramaService, EventoPerguntaService, EventoHotelService,
  NotificacaoService, ProdutoService, CampanhaEtapaService, CampanhaMetaService, OfflineCarroService, Util, ParametroWebServiceService, FingerprintService
} from "./services/";

import { LoaderComponent } from "./shared/loader/loader.component";
import ptBr from "@angular/common/locales/pt";
import { VoucherService } from './services/turismo/voucher.service';
import { IntranetGrupoService } from './services/intranet/grupo.service'
import { IntranetConteudoService } from "./services/intranet/conteudo.service";
import { IntranetArquivoService } from "./services/intranet/arquivo.service";
import { IntranetVoucherService } from "./services/intranet/voucher.service";
import { PensoesService, PadraoPensaoFornecedorService } from "./services/cadastro/pensoes.service";
import { NgxAuthComponent } from "./auth/auth.component";
import { BannerService } from "./services/cadastro/banner.service";
import { BannerAgenciaWhiteLabelService } from "./services/cadastro/banner-agencia-white-label.service";
import { BetoCarreroService } from "./services/turismo/betocarrero.service";
import { PoliticaVoucherService } from "./services/gerenciamento/politicavoucher.service";
import { TaxasExtrasService } from "./services/gerenciamento/taxasextras.service";
import { ComunicadosService } from "./services/gerenciamento/comunicados.service";
import { ContratoComponent } from './contrato/contrato.component';
import { GrupoService } from "./services/cadastro/grupo.service";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { DispositivosService } from "./services/cadastro/dispositivos.service";

registerLocaleData(ptBr);
@NgModule({
  entryComponents: [ConfirmacaoComponent],
  declarations: [AppComponent, LoaderComponent, NgxAuthComponent, ContratoComponent],
  imports: [
    SharedModule.forRoot(),
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    NbDatepickerModule.forRoot(),
    NbMomentDateModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    AppRoutingModule.forRoot(),
    // AutocompleteLibModule,
    NgbModule.forRoot(),
    ThemeModule.forRoot(),
    CoreModule.forRoot(),
    AuthModule,
    NgxLoadingModule.forRoot({}),
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyBrkaH4O7hF2lzoYlV_vXTo4XjCZYMKQeY'
    }),
  ],
  exports: [
    NbDatepickerModule,
    NbMomentDateModule,
  ],
  bootstrap: [AppComponent],
  providers: [
    { provide: APP_BASE_HREF, useValue: "/" },
    { provide: LOCALE_ID, useValue: "pt" },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    LoginService,
    UsuarioService,
    NgbActiveModal,
    EmpresaService,
    EzlinkService,
    TBOService,
    LaminasService,
    BannerService,
    CidadeService,
    EstadoService,
    LoaderService,
    AereoService,
    CircuitoService,
    AeroportoService,
    GrupoService,
    HotelService,
    CarroService,
    SeguroService,
    PacoteDestinoService,
    ConfirmacaoService,
    LogService,
    AgenciaService,
    PerfilMarkupService,
    ServicoService,
    HotelofflineService,
    CategoriaOfflineApartamentoService,
    ReservaService,
    OfflineApartamentoService,
    WsService,
    MarkupService,
    CacheHotelService,
    PaisService,
    MoedaService,
    SubFornecedorService,
    CambioService,
    MarkdownService,
    PerfilUsuarioService,
    PermissaoService,
    TarifacategoriaOfflineApartamentoService,
    ServicoOfflineService,
    ParametroService,
    ServicoOfflineFornecedorService,
    FormaPagamentoService,
    ContratosService,
    CondicaoPagamentoService,
    ServicoOfflineTarifaService,
    ServicoOfflineTarifaFaixaEtariaService,
    ServicoOfflinePerguntaService,
    ServicoOfflinePerguntaOpcaoService,
    OfflineHotelRegraTarifariaService,
    OfflineHotelManutencaoPeriodoService,
    OfflineServicoManutencaoPeriodoService,
    OfflineHotelPromocaoTarifaService,
    BloqueioAereoService,
    BloqueioAereoVooService,
    ProfissaoService,
    FinanciamentoService,
    TeleVendasPagamentoService,
    LojasCarroService,
    VoucherService,
    DashboardService,
    HotelBedsService,
    RiuService,
    RestelService,
    OfflineApartamentoRegimeService,
    OfflineApartamentoDisponibilidadeService,
    PalladiumService,
    IntranetCategoriaService,
    IntranetGrupoService,
    IntranetConteudoService,
    IntranetArquivoService,
    IntranetVoucherService,
    ReservaGestaoService,
    GrupoEconomicoService,
    FaturaService,
    TiposDeProdutosService,
    ProdutoOfflineService,
    ProdutoOfflineItemService,
    ProdutoOfflineFornecedorService,
    ProdutoService,
    ProdutoTipoService,
    ServicoOfflineTipoService,
    RelatorioService,
    PacoteService,
    PacoteHotelService,
    PacoteIncluiService,
    PacotePeriodoService,
    MarkupOfflineServicoService,
    PacoteBloqueioAereoService,
    PacoteTarifaService,
    EventoService,
    EventoHotelService,
    ProgramacaoService,
    CronogramaService,
    EventoPerguntaService,
    NotificacaoService,
    BlackListHotelService,
    CasaService,
    CampanhaEtapaService,
    CampanhaMetaService,
    OfflineCarroService,
    DatePipe,
    Util,
    PensoesService,
    PadraoPensaoFornecedorService,
    BannerAgenciaWhiteLabelService,
    ParametroWebServiceService,
    BetoCarreroService,
    PoliticaVoucherService,
    TaxasExtrasService,
    ComunicadosService,
    FingerprintService,
    DispositivosService
  ]
})
export class AppModule { }
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

// export function appInitializer(tokenService: TokenService) {
//   return () => {
//     tokenService.tokenValidatorIf().unsubscribe();
//   };
// }
